/* eslint no-console: ["error", { allow: ["warn", "error"] }] */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Form, Formik } from 'formik';

import { trim } from 'lodash';
import FormikInputGroup from '@components/smartAdminUI/input/FormikInputGroup';
import Button from '@components/smartAdminUI/Button';
import FormikHelper from '@components/form/formHelpers/FormikHelper';

import { loadComboBoxOptions } from '@redux/modules/formGeneration';

import {
  setSearchCriteria,
  loadListingSearchResults,
} from '@redux/modules/listing';

import { selectComboValueDict } from '@redux/selectors/FormSelector';
// import { components } from 'react-select';

const submitTranslation = {
  Lookup_Property_Listing_City: 'City',
  Lookup_Property_Listing_PropertyType: 'PropertyType',
  Lookup_Property_Listing_StandardStatus: 'StandardStatus',
  Lookup_Property_Listing_StreetSuffix: 'StreetSuffix',
};

const SearchCard = () => {
  const dispatch = useDispatch();

  const listingSearchLoading = useSelector(state => state.listing.searchLoading);

  const [comboClear, setComboClear] = useState(false);
  const [formEdited, setFormEdited] = useState(false);
  const [newComboValue, setNewComboValue] = useState({});
  const [resetFlag, setResetFlag] = useState(false);
  const [submitFlag, setSubmitFlag] = useState(false);

  const comboSetValueDict = useSelector(selectComboValueDict); // selector for combo dictionary in redux

  const comboBubbleWrap = {
    setNewComboValue,
  };

  // sets up the loading of combo values
  useEffect(() => {
    const newComboKeys = Object.keys(newComboValue);
    if (comboSetValueDict) {
      if (newComboKeys.length > 0) {
        const { fieldName, newValue } = newComboValue;
        const comboMutator = comboSetValueDict[fieldName];
        comboMutator(newValue);
      }
    }
  }, [newComboValue]);

  const lookupNames = { lookupNames: Object.keys(submitTranslation) };

  useEffect(() => {
    // API call to get combo box values on first render
    dispatch(loadComboBoxOptions(lookupNames));
  }, []);

  const buildWhereClause = values => {
    const whereClause = {
      clause: [],
      multiClause: [],
    };
    const multiValues = Object.keys(values).filter(val => val.toLocaleLowerCase() === 'standardstatus');
    const singleValues = Object.keys(values).filter(val => val.toLocaleLowerCase() !== 'standardstatus');
    singleValues.forEach(key => {
      if (values[key]) {
        whereClause.clause.push(
          {
            name: key,
            value: trim(values[key]),
          },
        );
      }
    });

    multiValues.forEach(key => {
      if (values[key]) {
        whereClause.multiClause.push(
          {
            name: key,
            value: trim(values[key]),
          },
        );
      }
    });
    return whereClause;
  };

  const formikSubmitClicked = values => {
    setSubmitFlag(true);
    dispatch(setSearchCriteria(values)); // save form values as search criteria in redux
  };

  const resetHandler = () => {
    setResetFlag(true); // resets formik state
    setComboClear(true); // resets combo values in FIG
    dispatch(setSearchCriteria('')); // resets search criteria values in state
  };

  // eslint-disable-next-line no-unused-vars
  const validateFigField = (x, y) => null; // will be used in future feature

  const handleSubmit = jsonBody => {
    dispatch(loadListingSearchResults(jsonBody));
  };

  return (
    <Formik
      onSubmit={values => formikSubmitClicked(values)}
      handleReset={resetHandler}
      initialValues={{
        ListingId: '',
        Lookup_Property_Listing_StandardStatus: '', // combo
        Lookup_Property_Listing_PropertyType: '', // combo
        StreetNumber: '',
        StreetName: '',
        Lookup_Property_Listing_StreetSuffix: '', // combo
        Lookup_Property_Listing_City: '', // combo
      }}
    >
      {() => (
        <Form className="col">
          <div className="form-row form-group">
            <div className="col-md-3 mb-1">
              <FormikInputGroup
                datatype="string"
                fieldLabel="Listing ID"
                FieldName="ListingId"
                inputType="TextInput"
                IsVisible
                validateFigField={validateFigField}
                maxLength={50}
              />
            </div>
            <div className="col-md-3 mb-1">
              <FormikInputGroup
                comboClear={comboClear}
                setComboClear={setComboClear}
                datatype="string"
                fieldLabel="Listing Status"
                FieldName="Lookup_Property_Listing_StandardStatus"
                inputType="ComboBox"
                multiselect
                IsVisible
                validateFigField={validateFigField}
                comboBubbleWrap={comboBubbleWrap}
              />
            </div>
            <div className="col-md-3 mb-1">
              <FormikInputGroup
                comboClear={comboClear}
                setComboClear={setComboClear}
                datatype="string"
                fieldLabel="Property Type"
                FieldName="Lookup_Property_Listing_PropertyType"
                inputType="ComboBox"
                IsVisible
                validateFigField={validateFigField}
                comboBubbleWrap={comboBubbleWrap}
              />
            </div>
          </div>
          <div className="form-row form-group">
            <div className="col-md-3 mb-1">
              <FormikInputGroup
                datatype="string"
                fieldLabel="Street Number"
                FieldName="StreetNumber"
                inputType="TextInput"
                IsVisible
                validateFigField={validateFigField}
                maxLength={50}
              />
            </div>
            <div className="col-md-3 mb-1">
              <FormikInputGroup
                datatype="string"
                fieldLabel="Street Name"
                FieldName="StreetName"
                inputType="TextInput"
                IsVisible
                validateFigField={validateFigField}
                maxLength={50}
              />
            </div>
            <div className="col-md-3 mb-1">
              <FormikInputGroup
                comboClear={comboClear}
                setComboClear={setComboClear}
                datatype="string"
                fieldLabel="Street Type"
                FieldName="Lookup_Property_Listing_StreetSuffix"
                inputType="ComboBox"
                IsVisible
                validateFigField={validateFigField}
                comboBubbleWrap={comboBubbleWrap}
              />
            </div>
            <div className="col-md-3 mb-1">
              <FormikInputGroup
                comboClear={comboClear}
                setComboClear={setComboClear}
                datatype="string"
                fieldLabel="City"
                FieldName="Lookup_Property_Listing_City"
                inputType="ComboBox"
                IsVisible
                validateFigField={validateFigField}
                comboBubbleWrap={comboBubbleWrap}
              />
            </div>
          </div>
          <Button name="btnSearchListing" variant="primary" type="submit">
            {listingSearchLoading ? (
              <>
                <span
                  className="spinner-border spinner-border-sm mr-2"
                  role="status"
                  aria-hidden="true"
                />
                Searching...
              </>
            ) : (
              <>
                <i className="fas fa-search mr-2" aria-hidden="true" />
                Search
              </>
            )}
          </Button>
          <Button name="btnSearchListingClear" onClick={resetHandler} variant="primary">
            <i className="fas fa-times mr-2" />
            Clear
          </Button>
          <FormikHelper
            buildWhereClause={buildWhereClause}
            formEdited={formEdited}
            lookupNames={lookupNames}
            onSubmitClicked={handleSubmit}
            resetFlag={resetFlag}
            setFormEdited={setFormEdited}
            setSubmitFlag={setSubmitFlag}
            submitFlag={submitFlag}
            setComboClear={setComboClear}
            setResetFlag={setResetFlag}
            submitTranslation={submitTranslation}
          />
        </Form>
      )}
    </Formik>
  );
};

export default SearchCard;
